import { defaultMenuOptions, mdmRegistry, mdmRegistryObj } from "../../features/mdm/mdmRegistry";
import { DomainValue, DomainValueConfig, MDMConfigType } from "./types";
import { ChannelkartNetworkGet } from "../networkService";
import { getMetaDataConfig, getUserRolesBasedOnAccess, isRoleConfigEnabled } from "../uiConfigService";
import { Role } from "../../components/userModal/userModalType";
import { getAccessToken } from "../authenticationService";
import { genericFilterType } from "../../stateManagement/reducers/genericFilterReducer";
import { FilterOption, filterRegistry } from "../../components/genericFilters/filterRegistry";
import { getAllConfiguartions } from "../updateMetaConfigService";
function isValidMDMconfigObj(mdmConfigObj: DomainValue ){
  if(mdmConfigObj.id && mdmConfigObj.name){
    return true;
  }
  return false;
}
export async function getMDMConfiguration(): Promise<DomainValue[]> {
  
  let mdmData: DomainValue[] = [];
  try {
    const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
    const allConfig = await getAllConfiguartions();
    const clientConfig = allConfig.data.features.filter((config: { domainName: string; }) => config.domainName === "clientconfig");
    const uiConfig = allConfig.data.features.filter((config: { domainName: string; }) => config.domainName === "uiconfig");
    const uiConfigKey = clientConfig.find((config: { domainType: string }) => config.domainType === "config")?.domainValues?.[0]?.["uiConfigKey"];
    const roleBasedAccess = isRoleConfigEnabled(clientConfig);
    let finalMdmList: DomainValue[] = [];
    const isAdmin = currentUserData.designation.includes("admin");
    if(isAdmin){
      const configName = "admin_mdm_configuration";
      const mdmConfig =  clientConfig.find((config: { domainType: string }) => config.domainType === configName);
      if(!mdmConfig){
        finalMdmList = getMdmConfig("admin",uiConfigKey,uiConfig)
        finalMdmList.forEach((configObj: DomainValueConfig | any) => {
          const newConfigObj = createNewConfigObj(configObj);
          mdmData.push(newConfigObj as DomainValue);
      });
      }else{
        if(mdmConfig?.domainValues){
          finalMdmList = [...mdmConfig?.domainValues]
        }
        processConfigObjects(finalMdmList, mdmRegistry, mdmData)
      } 
    }else{
      let mergedMdmConfig: DomainValue[] = [];
      let roles = getUserRolesBasedOnAccess(roleBasedAccess,currentUserData);
      for(let role of roles){
        const configName = `${role}_mdm_configuration`;
        const roleMdmConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
        if(roleMdmConfig?.domainValues){
          mergedMdmConfig = [...mergedMdmConfig,...roleMdmConfig.domainValues];
        }
      }
      finalMdmList = Array.from(new Set(mergedMdmConfig.map((item) => item.id))).map((id) => {
        return mergedMdmConfig.find((item) => item.id === id);
    }) as DomainValue[];
  
    if(finalMdmList.length===0){
      for(let role of roles){
        const roleMdmData = getMdmConfig(role,uiConfigKey,uiConfig)
        if(roleMdmData){
          mergedMdmConfig = [...mergedMdmConfig,...roleMdmData];
        }
      }
      finalMdmList = Array.from(new Set(mergedMdmConfig?.map((item) => item.id))).map((id) => {
        return mergedMdmConfig.find((item) => item.id === id);
      }) as DomainValue[];
      finalMdmList.forEach((configObj: DomainValueConfig | any) => {
        const newConfigObj = createNewConfigObj(configObj);
        mdmData.push(newConfigObj as DomainValue);
    });
    }
    else{
      processConfigObjects(finalMdmList, mdmRegistry, mdmData);
    }
    }
  } catch(error) {
    console.log(error);
    throw error;
  } finally {
    return mdmData;
  }
}
export async function getMasterData(
  entity: string | undefined
): Promise<string> {
  
  const url =
    "/v1/masterdatareports/" + entity + "?source=portal&callType=scheduled";
  const response = await ChannelkartNetworkGet(url);
  return (
    response.data.features[0]?.payload.url ?? "error"
  );
}

export function getFilterString(filterValues: genericFilterType,locationHierarchy?: boolean){
  let filter:string = "";
  let andFlag:boolean = false;
  if(filterValues.loginId){
    filter = filter + "userName.hierarchy[regex]:" + filterValues.loginId;
    andFlag = true;
  }
  const locationParam = locationHierarchy ? "locationHierarchy[regex][exact]:" : "location[regex]:";
  if(filterValues.branch){
    filter = filter + (andFlag ? " AND " : "") + locationParam + filterValues.branch;
    andFlag = true;
  }else if (filterValues.district){
    filter = filter + (andFlag ? " AND " : "") + locationParam + filterValues.district;
    andFlag = true;
  }
  const alreadyAddedFilters = ['loginId','branch','district','banner'];
  Object.keys(filterValues).forEach(filterKey=>{
    if(!alreadyAddedFilters.includes(filterKey) && filterValues[filterKey]){
      filter = filter + (andFlag ? " AND " : "") + filterKey + ":" + filterValues[filterKey];
      andFlag = true;
    }
  })
  return filter;
}

export function findReportsElement(data:any) {
  const reportsFeature = data?.componentConfig.features.find((feature: { id: string; }) => feature.id === "reports");
  if (reportsFeature) {
    const elements = reportsFeature.param.elements;
    const filterRegistryIds = filterRegistry.map(filter => filter.id);
    const modifiedElements = elements.map((element: { globalFilters: any[]; }) => {
      if (element.globalFilters) {
        element.globalFilters.forEach(filter => {
          if (!filterRegistryIds.includes(filter.id)) {
            filter.apiType = filter.customQueryObject && filter.customQueryObject.queryName ? `/v3/analyticsreport/custom?queryName=${filter.customQueryObject.queryName}` : "API";
            filter.multiSelect = filter.multiSelect;
            filter.id = filter.id;
            filter.label = filter.id;
            filter.parent = filter.parent;
            filter.filterConfig = {
              "filterKey" : filter.id
            }
          }
        });
      }
      return element;
    });
    return modifiedElements;
  } else {
    return null; 
  }
}

export function getReportConfig(role:any,uiConfigKey:any,uiConfig:any) {
  let configName = role;
  if(uiConfigKey){
  configName = `${role}-dashboard`;
  }
  const test = uiConfig.find((config: { domainType: string }) => config.domainType === configName);
  return findReportsElement(test?.domainValues[0])
}

export function findMdmElement(data:any) {
  const reportsFeature = data?.componentConfig.features.find((feature: { id: string; }) => feature.id === "mdmDashboard");
  if (reportsFeature) {
    const elements = reportsFeature.param.elements.map((element: any) => {
      const { templateurl, ...rest } = element;
      return {
        ...rest,
        templateUrl: templateurl
      };
    });
    return elements;
  } else {
    return null; 
  }
}

export function getMdmConfig(role:any,uiConfigKey:any,uiConfig:any) {
  let configName = role;
  if(uiConfigKey){
  configName = `${role}-dashboard`;
  }
  const test = uiConfig.find((config: { domainType: string }) => config.domainType === configName);
  return findMdmElement(test?.domainValues[0])
}

function createNewConfigObj(configObj: DomainValueConfig | any): any {
  const transformerInfo = configObj.transformer
      ? configObj.transformer
      : [{
          "entityName": configObj?.name,
          "transformerId": `default_${configObj?.name?.toLowerCase()}`
      }];
  
  const newconfigObj = {
      id: configObj.id,
      chainingJobName:configObj.chainingJobName,
      name: configObj.label ?? configObj.name,
      entity: configObj.name,
      designation: configObj.designation,
      fileType: configObj.type==="image"? "zip" : "excel",
      transformerInfo: transformerInfo,
      templateUrl: configObj.templateUrl,
      menuOption: [] as { id: string; icon: string; label: string }[],
      exportConfig: configObj.exportConfig
  };

  if(configObj.name.toLowerCase() === "division"){
    newconfigObj.menuOption.push({
      "id": "viewsAndEditDivision",
      "icon": "viewsAndEditIcon",
      "label": "Views and Edit"
    });
  }else{    
    newconfigObj.menuOption.push(
        {
            "id": "import",
            "icon": "importIcon",
            "label": "Import"
        },
        {
            "id": "logsAndReport",
            "icon": "logsAndReportIcon",
            "label": "Logs and Reports"
        },
    );

    if (configObj.hasOwnProperty('hasViewEdit') && configObj.hasViewEdit) {
      newconfigObj.menuOption.push({
          "id": "viewsAndEdit",
          "icon": "viewsAndEditIcon",
          "label": "Views and Edit"
      });
    }

    if (configObj.hasOwnProperty('masterDownloadTemp')) {
        newconfigObj.menuOption.push({
            "id": "masterDownload",
            "icon": "masterDownloadIcon",
            "label": "Master Download"
        });
    }
    else if (configObj.hasOwnProperty('masterReportEntity')) {
      newconfigObj.menuOption.push({
        "id": "masterDownload",
        "icon": "masterDownloadIcon",
        "label": "Master Download"
    });
    }
  }
  return newconfigObj;
}

function processConfigObjects(finalMdmList:DomainValue[], mdmRegistry:mdmRegistryObj[], mdmData:DomainValue[]) {
  finalMdmList.forEach((configObj) => {
    let isFound = false;
    mdmRegistry.forEach((registryObj) => {
      if (registryObj.id === configObj.id) {
        isFound = true;
        configObj = {
          ...registryObj,
          ...configObj,
          entity: registryObj.entity,
        };
        mdmData.push(configObj);
      }
    });
  });
}
